<template>
  <div class="segment">
    <div class="heading-container">
      <div class="row">
        <div class="title">
          <input-group v-if="isAb" placeholder="Variant Name" label="Variant Name" v-model="variantName" />
          <span v-else> 2.Message</span>
        </div>
        <i class="fas fa-info-circle" @mouseover="displayInfo('message-info')" @mouseleave="removeInfo('message-info')"
          style="margin: auto; margin-left: 1rem;"></i>
      </div>
      <div v-if="!isTemplate" class="save-button" @click="setTemplateModal(true)">
        Save as Template
      </div>
      <div class="template-name-modal" :style="{ display: templateModalOpen ? 'flex' : 'none' }"
        @click="() => setTemplateModal(false)">
        <div class="name-wrapper" @click="e => e.stopPropagation()">
          <input-group v-model="templateName" label="Name" placeholder="Enter template name" inline
            style="width: 100%;" />
          <div class="save-button" @click="saveTemplate">
            Save Template
          </div>
        </div>
      </div>
    </div>
    <div class="info" id="message-info">
      <pre>
          - If you want to keep a field empty, delete the default text.
          - You can also add emojis using control+command+spacebar shortcut.
          - You can change variant name by deleting the placeholder and writing your own explanatory variant name
        </pre>
    </div>
    <message-body v-on:modelEvent="newLanguage" v-model="messageBody" />
    <platform-settings v-model="platformSettings" />
    <other-settings v-model="otherSettings" />
  </div>
</template>

<script>
import MessageBody from "@/views/PushNotification/Components/Message/MessageBody";
import PlatformSettings from "@/views/PushNotification/Components/Message/PlatformSettings";
import OtherSettings from "@/views/PushNotification/Components/Message/OtherSettings";
import InputGroup from "@/views/PushNotification/UIComponents/InputGroup";
import { displayMixin } from "@/util/displayMixin.js"
import notify from "@/util/notification";
export default {
  name: "index",
  mixins: [displayMixin],
  model: {
    prop: "modelProp",
    event: "modelEvent"
  },
  props: {
    modelProp: Object,
    isAb: Boolean,
    isTemplate: Boolean,
  },
  components: {
    MessageBody,
    PlatformSettings,
    OtherSettings,
    InputGroup
  },
  data() {
    return {
      templateName: "",
      templateModalOpen: false
    }
  },
  computed: {
    variantName: {
      get() {
        return this.modelProp.variantName;
      },
      set(value) {
        this.$emit('modelEvent', { ...this.modelProp, variantName: value });
      }
    },
    messageBody: {
      get() {
        return this.modelProp.messageBody;
      },
      set(value) {
        this.$emit('modelEvent', { ...this.modelProp, messageBody: value });
      }
    },
    platformSettings: {
      get() {
        return this.modelProp.platformSettings;
      },
      set(value) {
        this.$emit('modelEvent', { ...this.modelProp, platformSettings: value });
      }
    },
    otherSettings: {
      get() {
        return this.modelProp.otherSettings;
      },
      set(value) {
        this.$emit('modelEvent', { ...this.modelProp, otherSettings: value });
      }
    }
  },
  methods: {
    newLanguage(data) {
      this.$emit('updatedLanguages', data)
    },
    setTemplateModal(value) {
      this.templateModalOpen = value
    },
    saveTemplate() {
      if (!this.templateName) {
        return notify('Template name cannot be empty.', 'error')
      }
      //template name should be unique
      const templates = this.$store.getters.templateMessages;
      let isNameExists = false;
      templates.forEach(template => {
        if (template.name == this.templateName) {
          isNameExists = true
        }
      });
      if (isNameExists) {
        return notify('Template name already exists.', 'error')
      }
      const payload = {
        name: this.templateName,
        status: 'template',
        messages: [
          this.modelProp
        ]
      }
      this.$store.dispatch('configAdd', { type: 'message', payload })
      this.templateModalOpen = false
    }
  }
}
</script>

<style scoped>
.segment {
  background-color: rgba(44, 44, 71, 0.46);
  margin: 30px 0;
  border-radius: 3px;
  padding: 20px 20px;
  color: white;
  font-size: 16px;
  font-weight: 400;
}

.title {
  font-size: 24px;
  font-weight: 500;
}

.heading-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
}

.template-name-modal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10;
}

.name-wrapper {
  position: relative;
  padding: 30px 70px;
  width: 50%;
  background-color: black;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #BB86FC;
  isolation: isolate;
  z-index: 11;
}

.save-button {
  display: inline;
  padding: 5px 10px;
  margin: 0 10px;
  cursor: pointer;
  border-radius: 5px;
  background: #BB86FC;
  color: white;
}
</style>